<template>
  <transition name="calendar-modal">
    <div class="calendar-modal-mask">
      <div class="calendar-modal-wrapper">
        <div class="calendar-modal-container position-relative">
          <div class="cancel calendar-cancel">
            <a class="btn btn--white" v-on:click="onReset()">
              <span class="d-none"> Close </span>
            </a>
          </div>

          <div class="calendar-modal-content">
            <div
              class="calendar-modal-header calendar-modal-header--warning p-3 p-xl-4"
            >
              <div class="calendar-modal-header-content">
                <div v-if="hasError">
                  <strong>Sorry!</strong> There is no availability for the
                  entered code on your selected dates.
                  <span class="warning-message-sub">
                    General availability is shown below.</span
                  >
                </div>
                <span v-else class="warning-message">
                  <strong>Sorry!</strong> There is no availability on your
                  selected dates.
                  <span v-if="hasCode" class="warning-message-sub">
                    Select new dates below, or
                    <a
                      class="continue-no-code"
                      v-on:click="onContinueWithNoCode()"
                    >
                      continue without a code</a
                    >.</span
                  >
                  <span v-else class="warning-message-sub">
                    Select new dates below.</span
                  >
                </span>
              </div>
            </div>

            <div
              class="d-flex justify-content-center mt-5 mb-5"
              v-if="isLoading"
            >
              <loader> </loader>
            </div>

            <div class="calendar-modal-body p-0 p-xl-2" v-if="!isLoading">
              <div class="calendar-control calendar">
                <div class="calendar-navigation">
                  <button
                    class="calendar-navigation-btn calendar-navigation-btn--prev"
                    v-on:click="onPreviousMonth()"
                  >
                    Back
                  </button>
                  <span class="month-name">{{ monthYear }}</span>
                  <button
                    class="calendar-navigation-btn calendar-navigation-btn--next"
                    v-on:click="onNextMonth()"
                  >
                    Next
                  </button>
                </div>

                <div class="table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th>Mon</th>
                        <th>Tue</th>
                        <th>Wed</th>
                        <th>Thu</th>
                        <th>Fri</th>
                        <th>Sat</th>
                        <th>Sun</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(calendarWeek, index) in calendarWeeks">
                        <td
                          v-for="(calendarDay, index2) in calendarWeek"
                          v-on:click="onClickDate(calendarDay)"
                        >
                          <div
                            class="calendar-day"
                            v-bind:class="getCssClass(calendarDay)"
                          >
                            <span class="day">
                              {{ formatDate(index, index2, calendarDay.Date) }}
                              <span v-if="calendarDay.MinLengthOfStay > 0"
                                ><strong>*</strong></span
                              ></span
                            >
                            <span v-if="!calendarDay.IsClosed" class="from"
                              >From</span
                            >
                            <span v-if="!calendarDay.IsClosed" class="price"
                              >£ {{ priceFormatted(calendarDay.Amount) }}</span
                            >

                            <span v-if="calendarDay.IsClosed" class="from"
                              >Unavailable</span
                            >
                            <span v-if="calendarDay.IsClosed" class="price"
                              >-</span
                            >
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="calendar-modal-footer my-3 mb-4">
                <div class="calendar-disclaimer p-3">
                  * Please note a minimum length of stay may apply to this date.
                </div>

                <button
                  class="btn btn--slate-blue btn--continue"
                  v-bind:disabled="isDisabled"
                  v-on:click="onContinue()"
                >
                  Book now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { store } from "../store/index";
import { _ } from "vue-underscore";
import moment from "moment";
import Loader from "@/shared/components/Loader.vue";

export default {
  name: "CalendarModal",
  data() {
    return {
      monthlyCalendar: null,
      isOddClick: false,
      newArrivalDate: null,
      newDepartureDate: null,
      newSeedDate: null,
      isLoading: true,
    };
  },
  components: {
    Loader,
  },
  props: {
    hasError: Boolean,
  },
  computed: {
    isDisabled() {
      return this.newArrivalDate == null || this.newDepartureDate == null;
    },
    session() {
      return store.getters.session;
    },
    booking() {
      return store.getters.booking;
    },
    search() {
      return store.getters.search;
    },
    hasCode() {
      if (this.search != null) {
        return (
          this.search.code != undefined &&
          this.search.code != null &&
          this.search.code.length
        );
      }
      return false;
    },
    calendarWeeks() {
      if (this.monthlyCalendar == null) {
        return [];
      } else {
        let dateGroups = _.groupBy(this.monthlyCalendar, "Date");
        let days = [];

        const objectArray = Object.entries(dateGroups);
        objectArray.forEach(([key, value]) => {
          let available = _.filter(value, function (roomDay) {
            return (
              roomDay.IsAvailable && roomDay.Units > 0 && !roomDay.IsClosed
            );
          });
          let sorted = _.sortBy(available, "Amount");

          if (sorted.length) {
            days.push(sorted[0]);
          } else {
            days.push({
              Date: key,
              Units: 0,
              IsAvailable: false,
              IsClosed: true,
            });
          }
        });

        let result = _.chunk(days, 7);

        return result;
      }
    },
    arrivalDate() {
      let arrivalDate = moment(this.newArrivalDate);
      return arrivalDate;
    },
    monthYear() {
      if (this.seedDate.date() == 1) {
        return this.seedDate.format("MMMM YYYY");
      } else {
        return this.seedDate.add(1, "M").startOf("month").format("MMMM YYYY");
      }
    },
    month() {
      let date = null;
      if (this.newSeedDate != null) {
        date = moment(this.newSeedDate);
      } else {
        let search = store.getters.search;
        date = moment(search.arrivalDate);
      }
      let startOfMonth = date.startOf("month");
      return startOfMonth;
    },
    seedDate() {
      return this.month.startOf("isoWeek");
    },
    departureDate() {
      let arrivalDate = moment(this.newDepartureDate);
      return arrivalDate;
    },
  },
  mounted() {
    this.loadCalendar();
  },
  methods: {
    onPreviousMonth() {
      this.newSeedDate = this.month.add(-1, "months").format("YYYY-MM-DD");
      this.loadCalendar();
    },
    onNextMonth() {
      let seedDate = this.month.add(1, "months").format("YYYY-MM-DD");

      if (moment(seedDate) < moment().add(2, "y")) {
        this.newSeedDate = seedDate;
        this.loadCalendar();
      }
    },
    loadCalendar() {
      this.isLoading = true;
      let payload = {
        sessionId: this.session.Id,
        arrivalDate: this.seedDate.format("YYYY-MM-DD"),
        numberOfNights: 41, //this is also weird, but its becuase it is inclusive of the start date...
        code: this.hasError ? null : this.search.code,
        //I've set this to be the first room occupancy - we dont show the calendar with availability for multiple rooms so needs to pick the first...
        guestOccupancies: [this.search.guestOccupancies[0]],
        leg: this.leg,
      };

      store.dispatch("fetchMonthlyCalendar", payload).then((t) => {
        this.monthlyCalendar = t;
        this.isLoading = false;
      });
    },
    formatDate(index, index2, date) {
      let mDate = moment(date);
      if (mDate.date() == 1 || (index == 0 && index2 == 0)) {
        return mDate.format("D MMM");
      }
      return mDate.format("D");
    },

    getCssClass: function (calDay) {
      let thisDate = moment(calDay.Date);

      let result = "";
      if (calDay.IsClosed) {
        result = "calendar-day--unavailable ";
      }

      if (
        thisDate.isBetween(this.arrivalDate, this.departureDate) ||
        thisDate.isSame(this.arrivalDate)
      ) {
        result += "stay";
      }
      if (thisDate.isSame(this.departureDate)) {
        result += " checkout";
      }

      return result;
    },

    onClickDate: function (calDay) {
      if (calDay.IsClosed) {
        return;
      }

      let date = calDay.Date;

      this.isOddClick = !this.isOddClick;

      let thisDate = moment(date);
      let formatted = thisDate.format("YYYY-MM-DD");

      if (this.isOddClick) {
        this.newArrivalDate = formatted;
        this.newDepartureDate = thisDate.add("1", "days").format("YYYY-MM-DD");
      } else {
        //need to check the days between and return false if overlaps

        if (this.arrivalDate.isAfter(thisDate)) {
          let perviousArrivalFormatted = this.newArrivalDate;
          this.newArrivalDate = formatted;
          this.newDepartureDate = perviousArrivalFormatted;
        } else {
          this.newDepartureDate = formatted;
        }
      }
    },
    onContinue() {
      let existingSearch = this.search;

      let mArrivalDate = moment(this.newArrivalDate);
      let mDepartureDate = moment(this.newDepartureDate);
      let days = mDepartureDate.diff(mArrivalDate, "days");

      let search = {
        sessionId: existingSearch.sessionId,
        guestOccupancies: existingSearch.guestOccupancies,
        code: this.hasError ? null : existingSearch.code,
        arrivalDate: this.newArrivalDate,
        numberOfNights: days,
      };

      let bookingPayload = {
        monetaryVouchers: this.booking.vouchers,
      };

      store.dispatch("clearPartialData").then(() => {
        store.dispatch("setSearch", search).then(() => {
          store.dispatch("createBooking", bookingPayload);
          store.dispatch("searchRooms", this.search);
        });
      });

      this.$emit("close");
    },
    onContinueWithNoCode() {
      let existingSearch = this.search;

      let search = {
        sessionId: existingSearch.sessionId,
        guestOccupancies: existingSearch.guestOccupancies,
        code: null,
        arrivalDate: existingSearch.arrivalDate,
        numberOfNights: existingSearch.numberOfNights,
      };

      let bookingPayload = {
        monetaryVouchers: this.booking.vouchers,
      };

      store.dispatch("clearPartialData").then(() =>
        store.dispatch("setSearch", search).then(() => {
          store.dispatch("createBooking", bookingPayload);
          store.dispatch("searchRooms", this.search);
        })
      );

      this.$emit("close");
    },

    priceFormatted(num) {
      if (num % 1 == 0) {
        return num;
      }

      return num.toFixed(2);
    },
    onReset() {
      let o = this;
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You will have to start over!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#a10000",
          cancelButtonColor: "#425261",

          confirmButtonText: "Continue",
          cancelButtonText: "Close",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "stay_search" });
          }
        });
    },
  },
};
</script>

<style>
.cancel.calendar-cancel {
  position: absolute;
}

.cancel.calendar-cancel a {
  padding: 25px;
  background-position: center center;
}

.continue-no-code {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

.table-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
}

.table-wrapper th {
  font-size: 12px;
}

.calendar-navigation-btn {
  background: none;
  border: none;
  text-indent: -9999px;
  background-repeat: no-repeat;
  background-size: 51px 10px;
  width: 51px;
  height: 10px;
  background-position: center center;
}

.calendar-navigation-btn.calendar-navigation-btn--next {
  background-image: url("@/assets/img/booking/month-calendar-next.svg");
}

.calendar-navigation-btn.calendar-navigation-btn--prev {
  background-image: url("@/assets/img/booking/month-calendar-prev.svg");
}

.calendar-disclaimer {
  background: white;
  text-align: left;
  font-size: 14px;
  width: 100%;
}

.warning-message {
  display: inline-block;
  margin-bottom: 0px !important;
  font-size: 18px;
  font-weight: 300;
  color: #4d4d4d;
  padding-left: 45px;
  background-image: url("@/assets/img/booking/warning-cross.svg");
  background-position: unset !important;
  background-size: 32px 32px;
  background-repeat: no-repeat;
}

.warning-message-sub {
  display: block;
  font-size: 16px;
  font-weight: 300;
  color: #4d4d4d;
}

.calendar-modal-mask {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.calendar-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.calendar-modal-container {
  /*        width: 90%;*/
  max-width: 1260px;
  margin: 0px auto;
  background-color: #eae5e3;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
}

.calendar-modal-content {
  flex-grow: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100vh;
}

.calendar-modal-header .calendar-modal-header-content {
  text-align: left;
}

.calendar-modal-header-content > div {
  padding-right: 45px;
}

.calendar-modal-header.calendar-modal-header--warning {
  background: rgba(178, 83, 61, 0.15);
}

.calendar-modal-body {
  margin: 10px 0;
}

.calendar-modal-default-button {
  float: right;
}

.calendar-modal-footer {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  max-width: 795px;
  margin: 0 auto;
}

.calendar-modal-footer .btn {
  min-width: 100%;
}

.calendar-modal-container .calendar-control {
  max-width: 795px;
  margin: auto;
  text-align: left;
}

.calendar-modal-container .calendar-control th {
  text-transform: uppercase;
}

.calendar-modal-container .calendar-control td {
  padding: 0.5px;
}

.calendar-modal-container .calendar-control .calendar-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  margin-top: 25px;
}

.calendar-modal-container .calendar-control .calendar-navigation .month-name {
  font-size: 21px;
}

.calendar-modal-container .calendar-day {
  display: flex;
  flex-direction: column;
  height: 75px;
  width: calc(100vw / 7);
  position: relative;
  background: #fff;
  padding: 10px 6px;
  justify-content: flex-end;
  font-family: Montserrat;
  cursor: pointer;
}

.calendar-modal-container .calendar-day--unavailable .from {
  display: none;
}

.calendar-modal-container .calendar-day--unavailable {
  background: #eee9e7;
  cursor: default;
}

.calendar-modal-container .stay {
  color: white;
  background: #a2905b;
}

.calendar-modal-container .checkout {
  position: relative;
  z-index: 1;
}

.calendar-modal-container .checkout:before {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  content: "";
  display: block;
  z-index: 2;
  width: 15px;
  background: rgba(162, 144, 91, 0.5);
}

.calendar-modal-container .calendar-day .day {
  position: absolute;
  top: 10px;
  left: 6px;
  font-size: 12px;
  font-weight: 300;
}

.calendar-modal-container .calendar-day .from {
  font-size: 12px;
  font-weight: 300;
}

.calendar-modal-container .calendar-day .price {
  font-size: 13px;
  font-weight: 600;
}

/*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

.calendar-modal-enter {
  opacity: 0;
}

.calendar-modal-leave-active {
  opacity: 0;
}

.calendar-modal-enter .calendar-modal-container,
.calendar-modal-leave-active .calendar-modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (min-width: 769px) {
  .calendar-modal-header .calendar-modal-header-content {
    text-align: center;
  }

  .calendar-modal-container .calendar-day {
    width: 109px;
    padding: 15px;
    height: 93px;
  }

  .calendar-modal-container .calendar-day .price {
    font-size: 16px;
    font-weight: 600;
  }

  .calendar-modal-container .calendar-day .day {
    position: absolute;
    top: 15px;
    left: 15px;
    font-size: 14px;
    font-weight: 300;
  }

  .calendar-modal-container .calendar-day .from {
    font-size: 12px;
    font-weight: 300;
  }

  .calendar-modal-container .calendar-day .price {
    font-size: 13px;
    font-weight: 600;
  }

  .calendar-modal-container .calendar-control td {
    padding: 2.5px;
  }

  .table-wrapper th {
    font-size: 16px;
  }

  .calendar-modal-container .calendar-day--unavailable .from {
    display: block;
  }

  .calendar-modal-container .calendar-control .calendar-navigation .month-name {
    font-size: 24px;
  }

  .warning-message {
    font-size: 21px;
  }

  .calendar-modal-footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    max-width: 795px;
    margin: 0 auto;
  }

  .calendar-modal-footer .btn {
    min-width: 230px;
  }
}
</style>
